import AuthLogin from "../../components/Auth/Login";

export default function Auth() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AuthLogin/>
    </div>
  );
}
